import { useCallback } from 'react'

import { SupportedEventData } from '@appTypes/GoogleTagManager.interface'

const useGoogleTagManager = () => {
    const dataLayer =
        typeof window !== 'undefined' && typeof window.dataLayer !== 'undefined'
            ? window.dataLayer
            : []

    const disable =
        typeof window === 'undefined' || process.env.NODE_ENV === 'development'

    const send = useCallback((eventData: SupportedEventData) => {
        if (dataLayer != null) {
            if (disable) {
                console.log('[GTM Event:disabled]', eventData)
                return
            }

            dataLayer.push(eventData)
        } else {
            console.log('[GTM Event]', eventData)
        }
    }, [])

    return send
}

export default useGoogleTagManager
